var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Smoothness"}},[_c('v-select',{attrs:{"options":_vm.options,"searchable":false,"reduce":val => val.value,"placeholder":"Smooth"},model:{value:(_vm.motionSmoothnes),callback:function ($$v) {_vm.motionSmoothnes=$$v},expression:"motionSmoothnes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }